// extracted by mini-css-extract-plugin
module.exports = {"full":"AIKbHYR_","center":"nIxmmeXc","total":"qPfDV_a3","totalIcon":"__4um_eaQG","totalNumber":"__6G_hyIwo"};